
const productosPertina = [
    
    {
        id: 1,
        nombre: 'Infinity',
        colores: ['Sunset','Luvina','Serenity'],
        categoria:'Pertina',
        peso:'175 g/ m2 + - 5%',
        images: [
            require ('../../assets/img/productos/pertina/pertinaInfinity/muestra.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaInfinity/2.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaInfinity/3.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaInfinity/4.jpg')
        ]
    },{
        id: 2,
        nombre: 'Dimmer',
        colores: ['Perla','Citrino','Onix'],
        categoria:'Pertina',
        peso:'235 g/ m2 + - 5%',
        images: [
            require ('../../assets/img/productos/pertina/pertinaDimmer/muestra.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaDimmer/2.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaDimmer/3.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaDimmer/4.jpg')
        ]
    },{
        id: 3,
        nombre: 'Rocks',
        colores: ['Cuarzo','Cantera','Agata'],
        categoria:'Pertina',
        peso:'195 g/ m2 + - 5%',
        images: [
            require ('../../assets/img/productos/pertina/pertinaRocks/muestra.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaRocks/1.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaRocks/2.jpg'), 
            require ('../../assets/img/productos/pertina/pertinaRocks/3.jpg')
        ]
    },{
        id: 4,
        nombre: 'Pin Dot',
        colores: ['Silver','Gold','Titanium'],
        categoria:'Pertina',
        peso:'195 g/ m2 + - 5%',
        images: [
            require ('../../assets/img/productos/pertina/pinDot/muestra.jpg'), 
            require ('../../assets/img/productos/pertina/pinDot/silver.jpg'), 
            require ('../../assets/img/productos/pertina/pinDot/gold.jpg'), 
            require ('../../assets/img/productos/pertina/pinDot/titanium.jpg')
        ]
    },{
        id: 5,
        nombre: 'Umbra',
        colores: ['Pragma','Bene','Argos', 'Nox'],
        categoria:'Pertina',
        peso:'195 g/ m2 + - 5%',
        images: [
            require ('../../assets/img/productos/pertina/umbra/muestra.jpg'), 
            require ('../../assets/img/productos/pertina/umbra/pragma.jpg'), 
            require ('../../assets/img/productos/pertina/umbra/bene.jpg'), 
            require ('../../assets/img/productos/pertina/umbra/argos.jpg'),
            require ('../../assets/img/productos/pertina/umbra/nox.jpg')
        ]
    },{
        id: 6,
        nombre: 'Snow',
        colores: ['Artic','Fog','Mist'],
        categoria:'Pertina',
        peso:'195 g/ m2 + - 5%',
        images: [
            require ('../../assets/img/productos/pertina/snow/muestra.jpg'), 
            require ('../../assets/img/productos/pertina/snow/artic.jpg'), 
            require ('../../assets/img/productos/pertina/snow/fog.jpg'), 
            require ('../../assets/img/productos/pertina/snow/mist.jpg')
        ]
    },{
        id: 7,
        nombre: 'Eliptic',
        colores: ['Axis','Orbis','Astra'],
        categoria:'Pertina',
        peso:'195 g/ m2 + - 5%',
        images: [
            require ('../../assets/img/productos/pertina/eliptic/muestra.jpg'), 
            require ('../../assets/img/productos/pertina/eliptic/axis.jpg'), 
            require ('../../assets/img/productos/pertina/eliptic/orbis.jpg'), 
            require ('../../assets/img/productos/pertina/eliptic/astra.jpg')
        ]
    }
].map(producto => ({
    ...producto,
    medidas: '5.80 x 6.00 m (Medidas máximas sugeridas)',
    boloqueo: 'Alto grado de privacidad',
    composicion: '100% Poliéster',
    slug:producto.nombre.toLowerCase().replace(/\s+/g, '-'),
    categoriaSlug: producto.categoria.toLowerCase().replace(/\s+/g, '-')
  }));
export default productosPertina;